const Fund = () => import(/* webpackChunkName: "fund" */ './Fund');
const attManager = () => import('./attaManagement');

export default {
  routes: [
    {
      path: '/fund',
      name: 'fund',
      component: Fund
    },
    {
      path: '/attManager',
      name: 'att_manager',
      component: attManager
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/fund/router.js